import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-mobile-menu',
  templateUrl: './landing-mobile-menu.component.html',
  styleUrls: ['./landing-mobile-menu.component.scss']
})
export class LandingMobileMenuComponent implements OnInit {
  isOpen: boolean = false;
  @Output() isOpenMenu = new EventEmitter<boolean>();
  constructor(private router: Router) { }
  scrolled: boolean = false;

  ngOnInit(): void {
  }
  openMenu() {
    this.isOpen = true;
    this.isMenuOpen();
  }
  closeMenu() {
    this.isOpen = false;
    this.isMenuOpen();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 640;
  }

  isMenuOpen(){
    this.isOpenMenu.emit(this.isOpen);
  }

  createRoulette() {
    this.router.navigate([`roulette`])
  }
}
